export default __webpack_public_path__ + "static/media/9c.c53f876f.png";